const Version = '2015-11-01';
const Service = 'sks';
const KecPath = '/kecapi/';

// 查询密钥列表接口
export const apiDescribeKeys = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeKeys',
        Service,
        Version
    }
};

// 创建ssh密钥接口
export const apiCreateKey = {
    basePath: KecPath,
    params: {
        Action: 'CreateKey',
        Service,
        Version
    }
};

// 删除ssh密钥接口
export const apiDeleteKey = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DeleteKey',
        Service,
        Version
    }
};

// 导入密钥接口
export const apiImportKey = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ImportKey',
        Service,
        Version
    }
};

// 主机解绑Key接口, 这个接口Version=2016-03-04 Service=kec
export const apiDetachKey = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DetachKey',
        Service: 'kec',
        Version: '2016-03-04'
    }
};

// 主机绑定Key接口, 这个接口Version=2016-03-04 Service=kec
export const apiAttachKey = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'AttachKey',
        Service: 'kec',
        Version: '2016-03-04'
    }
};

export const CheckKeyEncryption = {
    basePath: KecPath,
    params: {
        Action: 'CheckKeyEncryption',
        Version: '2016-03-04',
        Service: 'kec',
    },
    method: 'get'
};
export const DetachInstanceKey = {
    basePath: KecPath,
    params: {
        Action: 'DetachInstanceKey',
        Version: '2016-03-04',
        Service: 'kec',
    },
    method: 'post'
};

// 修改密钥所属项目
export const apiModifyKeyProject = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ModifyKeyProject',
        Service: 'sks',
        Version
    }
};